import * as tslib_1 from "tslib";
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { CategoryIcon, getMasterCategoryList } from 'owa-categories';
import DragAndDroppable from 'owa-dnd/lib/components/DragAndDroppable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { lazyRemoveFavoriteCategory } from 'owa-favorites';
import { isCategoryInFavorites, ToggleFavoriteButton } from 'owa-favorites';
import { lazyUpdateFavoritePosition } from 'owa-favorites';
import { showFavoritesContextMenu } from 'owa-mail-favorites-store/lib/actions/favoritesContextMenu';
import { selectFavoriteCategory } from 'owa-mail-folder-forest-actions';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { DRAG_X_OFFSET, DRAG_Y_OFFSET } from 'owa-mail-folder-view';
import { getAnchorForContextMenu } from 'owa-positioning';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
import { isFavoritingInProgress } from 'owa-mail-favorites-store';
var styles = require('./FavoriteNode.scss');
var CategoryNodeComputedState = /** @class */ (function () {
    function CategoryNodeComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(CategoryNodeComputedState.prototype, "category", {
        get: function () {
            var _this = this;
            return getMasterCategoryList().filter(function (categoryType) { return categoryType.Id === _this.props.categoryId; })[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoryNodeComputedState.prototype, "isSelected", {
        get: function () {
            return this.props.categoryId == getSelectedNode().id;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], CategoryNodeComputedState.prototype, "category", null);
    tslib_1.__decorate([
        computed
    ], CategoryNodeComputedState.prototype, "isSelected", null);
    return CategoryNodeComputedState;
}());
var FavoriteCategoryNode = /** @class */ (function (_super) {
    tslib_1.__extends(FavoriteCategoryNode, _super);
    function FavoriteCategoryNode(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCustomIcon = function (customIconClassNames) {
            return (React.createElement(CategoryIcon, { categoryName: _this.computedState.category.Name, iconClassName: customIconClassNames }));
        };
        _this.renderToggleFavorite = function () {
            return (React.createElement(ToggleFavoriteButton, { isInFavorites: isCategoryInFavorites(_this.props.categoryId), onClick: _this.removeFavoriteCategory, iconStyles: styles.favoriteButton }));
        };
        _this.onClick = function (evt) {
            evt.stopPropagation();
            selectFavoriteCategory(_this.props.categoryId);
        };
        _this.onContextMenu = function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            showFavoritesContextMenu(_this.props.favoriteId, 4 /* Category */, null, // Folder - no Folder Object passed in for Category context menu
            getAnchorForContextMenu(evt));
        };
        _this.removeFavoriteCategory = function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var removeFavoriteCategory;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.stopPropagation();
                        if (isFavoritingInProgress(this.props.categoryId)) {
                            // Do nothing: favoriting is in progress
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, lazyRemoveFavoriteCategory.import()];
                    case 1:
                        removeFavoriteCategory = _a.sent();
                        removeFavoriteCategory(this.props.categoryId, 'CategoryNodeFavoriteButton');
                        return [2 /*return*/];
                }
            });
        }); };
        // VSO 23480 - [FavoritesDND]Refactor the common DND code into a base component
        _this.getDragData = function () {
            var folderNodeDragData = {
                itemType: DraggableItemTypes.FavoriteNode,
                favoriteId: _this.props.favoriteId,
                favoriteType: 4 /* Category */,
                displayName: _this.computedState.category.Name,
            };
            return folderNodeDragData;
        };
        _this.getDragPreview = function (favoriteNodeDragData) {
            var elem = document.createElement('div');
            elem.className = styles.dragPreview;
            elem.innerText = favoriteNodeDragData.displayName;
            return elem;
        };
        _this.canDrop = function (dragData) {
            return dragData.itemType === DraggableItemTypes.FavoriteNode;
        };
        _this.onDrop = function (dragData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var draggedFavorite, dropTargetId, dragTargetId, updateFavoritePosition;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canDrop(dragData)) {
                            return [2 /*return*/];
                        }
                        draggedFavorite = dragData;
                        dropTargetId = this.props.favoriteId;
                        dragTargetId = draggedFavorite.favoriteId;
                        return [4 /*yield*/, lazyUpdateFavoritePosition.import()];
                    case 1:
                        updateFavoritePosition = _a.sent();
                        updateFavoritePosition(dragTargetId /* idToUpdate */, dropTargetId /* destinationFolderId */, draggedFavorite.favoriteType);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.computedState = new CategoryNodeComputedState(_this.props);
        return _this;
    }
    FavoriteCategoryNode.prototype.render = function () {
        return (React.createElement(DragAndDroppable, { getDragData: this.getDragData, getDragPreview: this.getDragPreview, xOffset: DRAG_X_OFFSET, yOffset: DRAG_Y_OFFSET, dropViewState: this.props.dropViewState, onDrop: this.onDrop, canDrop: this.canDrop },
            React.createElement(TreeNode, { onRenderCustomIcon: this.renderCustomIcon, displayName: this.computedState.category.Name, isRootNode: false, key: this.props.categoryId, isDroppedOver: this.props.dropViewState.isDragOver, onClick: this.onClick, isSelected: this.computedState.isSelected, renderRightCharmHover: this.renderToggleFavorite, onContextMenu: this.onContextMenu })));
    };
    FavoriteCategoryNode = tslib_1.__decorate([
        observer
    ], FavoriteCategoryNode);
    return FavoriteCategoryNode;
}(React.Component));
export default FavoriteCategoryNode;
//# sourceMappingURL=FavoriteCategoryNode.js.map